{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Kampane živého chatu",
      "NEW_CAMPAIGN": "Vytvoriť kampaň",
      "CARD": {
        "STATUS": {
          "ENABLED": "Zapnuté",
          "DISABLED": "Vypnuté"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Odoslal(a)",
          "BOT": "Bot",
          "FROM": "od",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nie sú dostupné žiadne kampane živého chatu",
        "SUBTITLE": "Spojte sa so svojimi zákazníkmi pomocou proaktívnych správ. Kliknite na 'Vytvoriť kampaň' pre začiatok."
      },
      "CREATE": {
        "TITLE": "Vytvoriť kampaň živého chatu",
        "CANCEL_BUTTON_TEXT": "Zrušiť",
        "CREATE_BUTTON_TEXT": "Vytvoriť",
        "FORM": {
          "TITLE": {
            "LABEL": "Názov",
            "PLACEHOLDER": "Zadajte názov kampane",
            "ERROR": "Názov je povinný"
          },
          "MESSAGE": {
            "LABEL": "Správa",
            "PLACEHOLDER": "Zadajte správu kampane",
            "ERROR": "Správa je povinná"
          },
          "INBOX": {
            "LABEL": "Vyberte schránku",
            "PLACEHOLDER": "Vyberte schránku",
            "ERROR": "Schránka je povinná"
          },
          "SENT_BY": {
            "LABEL": "Odoslal(a)",
            "PLACEHOLDER": "Vyberte odosielateľa",
            "ERROR": "Odosielateľ je povinný"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Please enter the URL",
            "ERROR": "Prosím zadajte platnú URL",
            "URL_IS_REGEXP": "Hodnota je regulárny výraz"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Čas na stránke (sekundy)",
            "PLACEHOLDER": "Zadajte čas",
            "ERROR": "Čas na stránke je povinný"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Ďalšie nastavenia",
            "ENABLED": "Povoliť kampaň",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Spustiť iba počas pracovných hodín"
          },
          "BUTTONS": {
            "CREATE": "Vytvoriť",
            "CANCEL": "Zrušiť"
          },
          "API": {
            "SUCCESS_MESSAGE": "Kampaň živého chatu bola úspešne vytvorená",
            "ERROR_MESSAGE": "Nastala chyba. Skúste to prosím znova."
          }
        }
      },
      "EDIT": {
        "TITLE": "Upraviť kampaň živého chatu",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Kampaň živého chatu bola úspešne aktualizovaná",
            "ERROR_MESSAGE": "Nastala chyba. Skúste to prosím znova."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS kampane",
      "NEW_CAMPAIGN": "Vytvoriť kampaň",
      "EMPTY_STATE": {
        "TITLE": "Nie sú dostupné žiadne SMS kampane",
        "SUBTITLE": "Spustite SMS kampaň, aby ste oslovili svojich zákazníkov priamo. Odosielajte ponuky alebo oznámenia jednoducho. Kliknite na 'Vytvoriť kampaň' pre začiatok."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Dokončené",
          "SCHEDULED": "Naplánované"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Odoslané z",
          "ON": "dňa"
        }
      },
      "CREATE": {
        "TITLE": "Vytvoriť SMS kampaň",
        "CANCEL_BUTTON_TEXT": "Zrušiť",
        "CREATE_BUTTON_TEXT": "Vytvoriť",
        "FORM": {
          "TITLE": {
            "LABEL": "Názov",
            "PLACEHOLDER": "Zadajte názov kampane",
            "ERROR": "Názov je povinný"
          },
          "MESSAGE": {
            "LABEL": "Správa",
            "PLACEHOLDER": "Zadajte správu kampane",
            "ERROR": "Správa je povinná"
          },
          "INBOX": {
            "LABEL": "Vyberte schránku",
            "PLACEHOLDER": "Vyberte schránku",
            "ERROR": "Schránka je povinná"
          },
          "AUDIENCE": {
            "LABEL": "Publikum",
            "PLACEHOLDER": "Vyberte štítky zákazníkov",
            "ERROR": "Publikum je povinné"
          },
          "SCHEDULED_AT": {
            "LABEL": "Plánovaný čas",
            "PLACEHOLDER": "Vyberte čas",
            "ERROR": "Plánovaný čas je povinný"
          },
          "BUTTONS": {
            "CREATE": "Vytvoriť",
            "CANCEL": "Zrušiť"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS kampaň bola úspešne vytvorená",
            "ERROR_MESSAGE": "Nastala chyba. Skúste to prosím znova."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Určite chcete vymazať?",
      "DESCRIPTION": "Akcia odstránenia je trvalá a nedá sa vrátiť späť.",
      "CONFIRM": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Kampaň bola úspešne odstránená",
        "ERROR_MESSAGE": "Nastala chyba. Skúste to prosím znova."
      }
    }
  }
}
